<template>
  <div class="main-bg certificate-page">
    <page-header title="我的证书" />
    <div v-if="loading" class="loading-box"></div>
    <el-empty v-else-if="!certList.length" description="暂无证书" />
    <!-- <el-table v-else :data="certList" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="participate_project" label="证书类型" width="120" />
      <el-table-column label="证书文件">
        <template #default="{ row }">
          <el-image v-if="row.file && row.file.length" :src="fileUrl + row.file[0].url" style="width: 100px; height: 100px;cursor: pointer;" fit="contain" @click="handlePreview(row.file[0].url)" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template #default="{ row }">
          <el-button v-if="row.file && row.file.length" type="text" @click="handlePreview(row.file[0].url)">预览</el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <div v-else class="credit-list">
      <div v-for="row in certList" :key="row.id" class="credit-item">
        <div class="credit-item-image">
          <el-image
            v-if="row.file && row.file.length"
            :src="fileUrl + row.file[0].url"
            style="width: 100%; height: 300px; cursor: pointer"
            fit="contain"
            @click="handlePreview(row.file[0].url)"
          />
        </div>
        <div class="credit-item-title">{{ row.participate_project }}</div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="证书预览" width="600px" @close="closeDialog">
      <div v-if="previewUrl">
        <img v-if="isImage(previewUrl)" :src="previewUrl" alt="证书图片" style="max-width: 100%; max-height: 70vh; display: block; margin: 0 auto" />
        <iframe v-else :src="previewUrl" style="width: 100%; height: 70vh; border: none"></iframe>
      </div>
      <template #footer>
        <el-button @click="closeDialog">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import API from '@/api'
import PageHeader from '@/components/PageHeader'
import Store from '@/store'
import { MessageBox } from 'element-ui'
const certList = ref([])
const loading = ref(true)
const dialogVisible = ref(false)
const previewUrl = ref('')
// 文件url
const fileUrl = ref(process.env.VUE_APP_FILE_URL)

function getUserInfo() {
  loading.value = true
  API.userInfo(Store.state.app.appConfig.school_id)
    .then(res => {
      if (+res.code === 200) {
        if (res.data === null) {
          MessageBox.confirm('您的登录凭证已失效，请重新登录', '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false,
            showClose: false,
            type: 'warning'
          })
            .then(() => {
              Store.dispatch('user/Logout')
            })
            .catch(() => {})
        } else {
          if (Array.isArray(res.data.professionalTechnicalBg)) {
            certList.value = res.data.professionalTechnicalBg
          }
        }
      } else {
        certList.value = []
      }
      loading.value = false
    })
    .catch(() => {
      certList.value = []
      loading.value = false
    })
}

function handlePreview(url) {
  previewUrl.value = fileUrl.value + url
  dialogVisible.value = true
}
function closeDialog() {
  dialogVisible.value = false
  previewUrl.value = ''
}
function isImage(url) {
  return /\.(png|jpe?g|gif|bmp|webp)$/i.test(url)
}

onMounted(() => {
  getUserInfo()
})
</script>

<style scoped lang="scss">
.certificate-page {
  padding: 32px;
}
.loading-box {
  margin: 32px 0;
}
.credit-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 16px;
  .credit-item {
    width: 50%;
    margin-top: 16px;
    .credit-item-title {
      text-align: center;
    }
  }
}
</style>
